import script from "./PageMeta.vue?vue&type=script&lang=js"
export * from "./PageMeta.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__